import { defaultValue as defaultIdType } from './idTypes';
import { defaultValue as defaultCreditorType } from './creditorTypes';

type DefaultDataFieldValues = {
  idType: string;
  creditorType: string;
  idNumber: string;
  currentBank: string;
  creditAmount: number;
  legalEntityCountry: string;
  pep: boolean;
  bloodRelatedToPep: boolean;
  cicac: boolean;
  pepLawArticle: boolean;
};

const defaultDataFieldValues: DefaultDataFieldValues = {
  idType: defaultIdType,
  creditorType: defaultCreditorType,
  idNumber: '',
  currentBank: '',
  creditAmount: NaN,
  legalEntityCountry: '005', // <-- Corresponds to Costa Rica
  pep: false,
  bloodRelatedToPep: false,
  cicac: false,
  pepLawArticle: false,
};

export default defaultDataFieldValues;
